import Vue from "vue";
import VueTelInputVuetify from "vue-tel-input-vuetify";
import vuetify from "./vuetify";

Vue.use(VueTelInputVuetify, {
  vuetify,
});
